<template>
  <div id="facility">
    <div class="con_all">
      <div class="con_box2">
        <div class="psear mb10">
          <div class="ca_l">
            <span class="con_title con_title_line">{{showPage.facility}}</span>
          </div>
          <div class="ca_l">
            <div class="ca_r">
              <router-link :to="{ name: 'class_item', params:{classname: className}}">
                <button class="ca_btn">{{showPage.class_item}}</button>
              </router-link>
            </div>
            <div class="ca_r2">
              <router-link :to="{ name: 'coach_info', params:{classname: className}}">
                <button class="ca_btn">{{showPage.coach_info}}</button>
              </router-link>
            </div>
            <div class="ca_r2">
              <router-link :to="{ name: 'class_inside', params:{classname: className}}">
                <button class="ca_btn">{{showPage.class_inside}}</button>
              </router-link>
            </div>
          </div>
        </div>
        <div class="fix" style="margin-bottom: 20px;"></div>
        <div class="team_bbox" v-html="showSite()"></div>
        <div class="fix"></div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios';
import { API, Message, ShowPage } from '@/assets/project_setting/config';
import { GetErrorHandler, ShowMessage } from '@/assets/library/axiosErrorHandler';

export default {
  name: 'facility',
  props: ['classitem'],
  data() {
    return {
      className: this.$route.params.classname,
      showPage: ShowPage(sessionStorage.getItem('locale'))
    };
  },
  created() {
  },
  methods: {
    

    showSite() {
      return sessionStorage.locale === 'CH' ? (this.classitem.siteCh) : (this.classitem.siteEn);
    }
  },
}

</script>
<style lang="scss">


</style>



// WEBPACK FOOTER //
// Facility.vue?74360dc6